import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './filter-tags.scss.js';
import { getStyleClassNames } from '../../utilities/constants/styles.constants.js';

class FilterTags extends s {
    constructor() {
        super(...arguments);
        this._tagNames = [];
        this.additionalClasses = '';
        this.marginBottom = '';
        this.marginTop = '';
        this.justifyContent = 'center';
    }
    set tagNames(value) {
        this._tagNames = [...value];
        this.requestUpdate('tagNames', value);
    }
    get tagNames() {
        return this._tagNames;
    }
    handleTagClick(tag) {
        this.dispatchEvent(new CustomEvent('tag-selected', {
            detail: tag,
            bubbles: true,
            composed: true,
        }));
        this.tagNames = this.tagNames.map(t => t.title === tag.title ? Object.assign(Object.assign({}, t), { active: true }) : Object.assign(Object.assign({}, t), { active: false }));
    }
    render() {
        const containerClassNames = getStyleClassNames({
            marginBottom: this.marginBottom,
            marginTop: this.marginTop,
            additionalClasses: `${this.additionalClasses}`,
        });
        const justifyContentStyle = `justify-content: ${this.justifyContent};`;
        const renderTags = this.tagNames.map(tag => $ `<simple-tag ?active="${tag.active}" @click="${() => this.handleTagClick(tag)}">${tag.title}</simple-tag>`);
        return $ `<div class="tag-component ${containerClassNames}"><div class="title"><slot name="title"></slot></div><div class="tagContainer" style="${justifyContentStyle}">${renderTags}</div></div>`;
    }
}
FilterTags.styles = css_248z;
__decorate([
    e({ type: Array })
], FilterTags.prototype, "tagNames", null);
__decorate([
    e({ type: String })
], FilterTags.prototype, "additionalClasses", void 0);
__decorate([
    e({ type: String })
], FilterTags.prototype, "marginBottom", void 0);
__decorate([
    e({ type: String })
], FilterTags.prototype, "marginTop", void 0);
__decorate([
    e({ type: String })
], FilterTags.prototype, "justifyContent", void 0);
customElements.define('filter-tags', FilterTags);

export { FilterTags };
